<template>
  <div class="padding-12 radius" :class="customClass" @click="onClick">
    <div class="flex align-center justify-between">
      <div>
        <span class="text-bold">顺风车</span>
        <van-tag
          class="margin-left-4"
          plain
          color="#999999"
          v-if="data.orderState === -1"
          >已取消</van-tag
        >
        <van-tag
          class="margin-left-4"
          plain
          color="#08a34d"
          v-if="data.orderState === 1"
          >待出行</van-tag
        >
        <van-tag
          class="margin-left-4"
          plain
          color="#08a34d"
          v-if="data.orderState === 2"
          >行程中</van-tag
        >
        <van-tag
          class="margin-left-4"
          plain
          color="#08a34d"
          v-if="data.orderState === 3"
          >已完成</van-tag
        >
      </div>
      <div class="text-12 text-grey1">
        {{ $moment(data.predictArriveOriginTime).format("YYYY-MM-DD HH:mm") }}
      </div>
    </div>
    <div class="padding-tb-12 border-bottom text-grey1">
      <div class="text-grey text-12 padding-left-12 margin-bottom-12 ball ball-from">
        {{ data.startAddress }}
      </div>
      <div class="text-grey text-12 padding-left-12 ball ball-to">
        {{ data.endAddress }}
      </div>
    </div>

    <div class="flex justify-between align-center text-grey1 padding-top-12">
      <div>订单号：{{ data.bizId }}</div>
      <div class="flex align-center" v-if="showComplaint"  @click.stop="goComplaint">
        <img src="~assets/images/kf/tousu.png" width="14px" alt="" srcset="">
        <span class="margin-left-2">投诉反馈</span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tag } from 'vant'

Vue.use(Tag)
export default {
  props: {
    customClass: {
      type: Array,
      default: () => []
    },
    data: {
      type: Object,
      require: true
    },
    showComplaint: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onClick () {
      this.$emit('select', this.data)
    },
    goComplaint () {
      // const path = this.data.questionOrderCount === 0
      //   ? `/service/complaint/add/${this.data.bizId}/${this.data.bizType}`
      //   : `/service/progress/detail/${this.data.bizId}`

      // this.$router.push(path)

      this.$router.push(`/service/complaint/add/${this.data.bizId}/${this.data.bizType}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.ball {
  position: relative;
  &::before {
    content: "";
    position: absolute;
    width: 5px;
    height: 5px;
    left: 1px;
    top: 50%;
    margin-top: -4px;
    border-radius: 50%;
  }
}
.ball-from {
  &::before {
    background-color: $primary;
  }
}
.ball-to {
  &::before {
    background-color: $green;
  }
}
</style>
